import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-camera-container',
    templateUrl: './camera-container.component.html',
    styleUrls: ['./camera-container.component.css'],
    standalone: false
})
export class CameraContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
